import ActivityStatusTypeProvider  from './ActivityStatusTypeProvider'

export default ActivityStatusTypeProvider
